/* eslint-disable max-len */

import React from 'react';

import moment from 'moment';

import { enum as ranks } from '../../../../../../enums/affiliate-ranks';

import { formatMoney } from '../../../shared/format';
import pluralize from '../../../../../shared/js/pluralize';

const img = {
	country: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/country.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/country.jpg')
	},
	growth: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/growth.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/growth.jpg')
	},
	income: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/income.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/income.jpg')
	},
	leads: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/leads.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/leads.jpg')
	},
	month: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/month.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/month.jpg')
	},
	offer: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/offer.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/offer.jpg')
	},
	offers: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/offers.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/offers.jpg')
	},
	preview: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/preview.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/preview.jpg')
	},
	quids: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/quids.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/quids.jpg')
	},
	final: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/final.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/final.jpg')
	},
	managers: {
		en: {
			50: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/managers/50.jpg'),
			61: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/managers/61.jpg'),
			63: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/managers/63.jpg'),
			75: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/managers/75.jpg'),
			80: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/managers/80.jpg'),
			81: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/managers/81.jpg'),
			90: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/managers/90.jpg'),
			94: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/managers/94.jpg')
		},
		ru: {
			50: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/managers/50.jpg'),
			61: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/managers/61.jpg'),
			63: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/managers/63.jpg'),
			75: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/managers/75.jpg'),
			80: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/managers/80.jpg'),
			81: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/managers/81.jpg'),
			90: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/managers/90.jpg'),
			94: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/managers/94.jpg')
		}
	},
	ranks: {
		en: {
			0: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/0.jpg'),
			1: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/1.jpg'),
			2: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/2.jpg'),
			3: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/3.jpg'),
			4: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/4.jpg'),
			5: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/5.jpg')
		},
		ru: {
			0: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/0.jpg'),
			1: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/1.jpg'),
			2: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/2.jpg'),
			3: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/3.jpg'),
			4: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/4.jpg'),
			5: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/5.jpg')
		}
	}
};

function Background({ image, visible, children }) {
	return (
		<div
			className='year-results-popup-background'
			style={{
				backgroundImage: `url('${image}')`,
				opacity: visible ? 1 : 0,
				zIndex: visible ? 1 : 0
			}}
		>
			{children}
		</div>
	);
}

export function Preview({ lang, visible }) {
	return (
		<Background visible={visible} image={img.preview[lang]} />
	);
}

export function Leads({ intl, lang, visible, leads }) {
	const count = leads ? leads.count : 0;

	return (
		<Background visible={visible} image={img.leads[lang]}>
			<div className='year-results-popup-value'>
				<span>{formatMoney(count)}</span> {intl(pluralize(count, ['лид', 'лида', 'лидов']))}
			</div>
		</Background>
	);
}

export function Income({ lang, visible, income }) {
	return (
		<Background visible={visible} image={img.income[lang]}>
			<div className='year-results-popup-value'>
				<span>{formatMoney(income)}</span> $
			</div>
		</Background>
	);
}

export function Quids({ lang, visible, quids }) {
	return (
		<Background visible={visible} image={img.quids[lang]}>
			<div className='year-results-popup-value'>
				<span>{formatMoney(quids)}</span> QUID
			</div>
		</Background>
	);
}

export function Growth({ lang, visible, leads }) {
	const percent = leads ? leads.percent : 0;

	return (
		<Background visible={visible} image={img.growth[lang]}>
			<div className='year-results-popup-value'>
				<span>{formatMoney(percent < 0 ? 0 : percent)}</span> %
			</div>
		</Background>
	);
}

export function Offers({ intl, lang, visible, offers }) {
	return (
		<Background visible={visible} image={img.offers[lang]}>
			<div className='year-results-popup-value'>
				<span>{formatMoney(offers)}</span> {intl(pluralize(offers, ['оффер', 'оффера', 'офферов']))}
			</div>
		</Background>
	);
}

export function Offer({ lang, visible, offer }) {
	return (
		<Background visible={visible} image={img.offer[lang]}>
			<div className='year-results-popup-offer'>
				<div className='year-results-popup-offer-image' style={{ backgroundImage: offer && `url('${offer.image}')` }} />
				<div className='year-results-popup-offer-value'>
					{offer && offer.title}
				</div>
			</div>
		</Background>
	);
}

export function Country({ lang, visible, country }) {
	return (
		<Background visible={visible} image={img.country[lang]}>
			<div className='year-results-popup-country'>
				<div className='year-results-popup-country-flag'>
					{country && (
						<span className={`flag-icon flag-icon-${country.code.toLowerCase()}`} />
					)}
				</div>
				{country && country.name}
			</div>
		</Background>
	);
}

export function Month({ lang, visible, month }) {
	return (
		<Background visible={visible} image={img.month[lang]}>
			<div className='year-results-popup-month'>
				{month && moment().locale(lang).month(month - 1).format('MMMM')}
			</div>
		</Background>
	);
}

export function Rank({ lang, visible, rank_id }) {
	return (
		<Background visible={visible} image={img.ranks[lang][rank_id]} />
	);
}

export function Manager({ lang, visible, manager }) {
	return manager && (
		<Background visible={visible} image={img.managers[lang][manager.id]} />
	);
}

export function Final({ lang, visible, leads, income, quids, offers, offer, country, month, rank_id, manager }) {
	const percent = leads ? leads.percent : 0;

	return (
		<Background visible={visible} image={img.final[lang]}>
			<div className='year-results-popup-final-leads'>
				{formatMoney(leads ? leads.count : 0)}
			</div>
			<div className='year-results-popup-final-income'>
				{formatMoney(income)}$
			</div>
			<div className='year-results-popup-final-quids'>
				{formatMoney(quids)}
			</div>
			<div className='year-results-popup-final-rank'>
				{ranks.find((r) => r.id === rank_id).name}
			</div>
			<div className='year-results-popup-final-country'>
				{country && country.name}
			</div>
			<div className='year-results-popup-final-offer'>
				{offer && offer.title}
			</div>
			<div className='year-results-popup-final-month'>
				{month && moment().locale(lang).month(month - 1).format('MMMM')}
			</div>
			<div className='year-results-popup-final-manager'>
				{manager && manager.name}
			</div>
			<div className='year-results-popup-final-percent'>
				{formatMoney(percent < 0 ? 0 : percent)}%
			</div>
			<div className='year-results-popup-final-offers'>
				{formatMoney(offers)}
			</div>
		</Background>
	);
}



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/year-results-popup/banners.js